'use strict';

module.exports = angular.module('superdostavka.commonFilters', [])
// Проверка $sce на сайте выключена: HTML выводится как есть. Фильтр нужен блокам из БД.
.filter("html", function() {
    return function(htmlCode) {
        return htmlCode;
    };
})
.filter('tel', ['locale_config', function (locale_config) {
    return function (tel) {
        // country = country || 'rus'

        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        country = '+' + locale_config.country_code;
        switch (value.length) {
            case 9: // +1PPP####### -> C (PPP) ###-####
                city = value.slice(0, 2);
                number = value.slice(2);
                break;

            case 10: // +1PPP####### -> C (PPP) ###-####
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            default:
                return tel;
        }

        if (country == 1) {
            country = "";
        }

        number = number.slice(0, 3) + '-' + number.slice(3, 5) + '-' + number.slice(5);

        return (country + " (" + city + ") " + number).trim();
    };
}])
.filter('declint', function() {
    return function(one,number,two,many) {

        var titles = [one,two,many];

        return (titles[(number%100>4 && number%100<20) ?  2 : ([2, 0, 1, 1, 1, 2])[Math.min(number%10, 5)]]);
    };
});
